const feedbackBtnSelector = '.feedback-btn';
const feedbackFormSelector = '.feedback-form';
const reCaptchaSelector = '.g-recaptcha';
const hostAttr = 'data-api-host';
const siteLoader = document.querySelector('.site-loader-modal');
const feedbackUrl = '/feedback';
const navSlug = document.querySelector('meta[name="cv-nav-slug"]');
const oemSlug = document.querySelector('meta[name="cv-oem-slug"]');

function feedbackPageUrl(){
    const topicParam = encodeURIComponent(window.location.href);
    const titleParam = encodeURIComponent(document.title);
    return `${feedbackUrl}?topic=${topicParam}&title=${titleParam}&nav=${navSlug.getAttribute('content')}&oem=${oemSlug.getAttribute('content')}`;
}


function initFeedbackForm(){
    document.querySelectorAll(feedbackFormSelector).forEach( form => {
        form.querySelector(reCaptchaSelector).setAttribute('data-callback', executeCaptcha.name );
        form.querySelector(reCaptchaSelector).setAttribute('data-error-callback', reCaptchaErrorCallback.name );
        function submitHandler(e) {
            e.preventDefault();
            if(grecaptcha){
                //disable the submit button for 1 second 
                //to avoid duplicate tokens
                const feedbackBtn = e.target.querySelector('.btn');
                feedbackBtn.disabled = true;
                setTimeout(()=>{
                    feedbackBtn.disabled = false;
                }, 1000);
                                
                //execute the grecaptcha check
                grecaptcha.execute();
            }else
                console.log("ERROR : grecaptcha object is null")
        }
        form.addEventListener('submit', submitHandler);
    });
}

function executeCaptcha(token){
    submitFeedback(token);
}

function reCaptchaErrorCallback(){
    console.log("Some error occurred while verifying grecaptcha");
    const feedbackForm = document.querySelector('.feedback-form');
    const feedbackBtn = feedbackForm.querySelector('.btn')
    feedbackBtn.disabled = false;
}

function submitFeedback(reCaptchaToken){
    siteLoader.classList.add('show');
    
    const feedbackForm = document.querySelector(feedbackFormSelector);
    
    let feedbackData = {
        'source': window.location.hostname,
        'url': feedbackForm.querySelector('#topic_url').value,
        'title': feedbackForm.querySelector('#topic_title').value,
        'email': feedbackForm.querySelector('#feedback_email').value,
        'name': feedbackForm.querySelector('#feedback_name').value,
        'comments': feedbackForm.querySelector('#feedback_text').value,
        'type': feedbackForm.querySelector('[name="feedback_type"]:checked').value,
        'tr_number': feedbackForm.querySelector('#feedback_tr_number').value,
        'nav_slug' : navSlug.getAttribute('content'),
        'g-recaptcha-response' : reCaptchaToken 
    };

    let host = feedbackForm.getAttribute(hostAttr);
    if (!host){
        host = '';
    }
    console.log(`using ${host}`);
    fetch(host + feedbackUrl, {
            'method': 'POST',
            'headers': {
                'content-type': 'application/json',
                'accept': 'text/html',
            },
            'cache': 'no-cache',
            'body': JSON.stringify(feedbackData)
        })
        .then(function (response) {
            return response.text();
        })
        .then(function (html) {
            siteLoader.classList.remove('show');
            feedbackForm.innerHTML = html;
        })
        .catch(err => {
            siteLoader.classList.remove('show');
            feedbackForm.innerHTML = '<p>Something went wrong. Reload the page and try again.</p>';
        });
}

function feedbackBtnHandler(e){
    const feedbackBtn = e.target.closest(feedbackBtnSelector);
    if (feedbackBtn){
        feedbackBtn.setAttribute('href', feedbackPageUrl());
    }
}

export default {feedbackBtnHandler, initFeedbackForm};